import {css} from 'lit';
import {smartphoneOnly, tablet, desktop, large1440, large1920} from '../../js/services/const';

export default css`
  h1, .h1 {
    font-family: var(--font-family-sans-serif);
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 3.2rem;
    margin-bottom: 0.8rem;
  }
  @media (min-width: ${tablet}px) {
    h1, .h1 {
      font-size: 3.2rem;
      line-height: 4.0rem;
      padding-bottom: 2.6rem;
    }
  }
  @media (min-width: ${large1440}px) {
    h1, .h1 {
      font-size: 4rem;
      line-height: 4.8rem;
      padding-bottom: 2.6rem;
    }
  }
  @media (min-width: ${large1920}px) {
    h1, .h1 {
      font-size: 4.6rem;
      line-height: 5.4rem;
    }
  }

  h2, .h2 {
    font-family: var(--font-family-sans-serif);
    font-weight: 700;
    font-size: 2rem;
    line-height: 2.6rem;
    margin: 3.6rem 0 1.2rem;
  }
  @media (min-width: ${tablet}px) {
    h2, .h2 {
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }
  @media (min-width: ${large1440}px) {
    h2, .h2 {
      font-size: 3.2rem;
      line-height: 4.0rem;
    }
  }

 h3, .h3 {
  font-family: var(--font-family-sans-serif);
  font-weight: 700;
  font-size: 1.6rem;
  line-height: 2.4rem;
  margin: 1.6rem 0 1.2rem;
  }
  @media (min-width: ${tablet}px) {
    h3, .h3 {
      font-size: 2rem;
      line-height: 3.2rem;
    }
  }
  @media (min-width: ${desktop}px) {
    h3, .h3 {
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  h4, .h4 {
    font-family: var(--font-family-sans-serif);
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 2.4rem;
    margin: 1.6rem 0 1.2rem;
  }
  @media (min-width: ${desktop}px) {
    h4, .h4 {
      font-size: 2rem;
      line-height: 3.2rem;
    }
  }
  h5, .h5 {
    font-family: var(--font-family-sans-serif);
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 2.4rem;
  }

  a {
    color: var(--system-hyperlink);
  }
  p, dl {
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-family: var(--font-family-sans-serif);
  }
  p {
    font-size: 1.6rem;
    line-height: 2.6rem;
  }
  @media (max-width: ${smartphoneOnly}px) {
    p {
      line-height: 2.5rem;
    }
  }
  @media (min-width: ${tablet}px) {
    p {
      font-size: 1.8rem;
      line-height: 2.6rem;
    }
  }
  p:empty {
    font-size: 0;
    line-height: 0;
    margin: 0;
  }
  p > a:hover, li > a:hover {
    background-color: var(--link-bg-hover);
  }
`;
